import React from "react";
import { useTranslation } from "react-i18next";

// Mobile controls stay in CSS pixels, outside Konva's transformed drawing.
export default function MobileDimensions({ lengths, heights, indexToChar, onLengthChange, onHeightChange }: any) {
  const { t } = useTranslation("tool");
  return <div className="mobile-drawing-dimensions">
    {(lengths || []).map((side, index) => <label key={side.id}>
      <span>{t("length")} <b dir="ltr">{indexToChar(index)}</b></span>
      <input type="number" inputMode="decimal" dir="ltr" value={Math.round(side.length) || ""}
        onChange={event => onLengthChange({ id: String(side.id), length: Math.round(Number(event.target.value)) })} />
    </label>)}
    {(heights || []).map((height, index) => <label key={height.id}>
      <span dir="ltr">h{index + 1}</span>
      <input type="number" inputMode="decimal" dir="ltr" value={height.height || ""}
        onChange={event => onHeightChange(parseInt(event.target.value), index, height.id, height.angle)} />
    </label>)}
  </div>;
}
